var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch, Ref } from "vue-facing-decorator";
import { DataCollectorRegisterClient, SitesClient, SystemsClient, GetDataCollectorRegisterListPaginatedQuery, GetSiteListQuery, AddDataCollectorRegisterCommand, DataCollectorRegisterModel, PaginatedEnumerableOfDataCollectorRegisterModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
const siteClient = new SitesClient(window.apiUrl);
const systemClient = new SystemsClient(window.apiUrl);
const dataCollectorRegistersClient = new DataCollectorRegisterClient(window.apiUrl);
let DataCollectorRegisterVue = class DataCollectorRegisterVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.showRegisterModal = false;
        this.saveButtonDisabled = false;
        this.sites = [];
        this.systems = [];
        this.model = new DataCollectorRegisterModel();
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "WhenCreated",
            direction: SortDirection.Descending
        }));
        // models
        this.query = new GetDataCollectorRegisterListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfDataCollectorRegisterModel();
    }
    created() {
        this.search();
    }
    ;
    getLookups() {
        this.working = true;
        var promises = [
            siteClient
                .getListPOST(new GetSiteListQuery({ companyId: this.companyId })),
            systemClient
                .getSystems()
        ];
        Promise.all(promises)
            .then((values) => {
            this.sites = (values[0] || []).map(item => {
                return {
                    value: item.siteId,
                    text: item.siteName || ""
                };
            });
            let systems = (values[1] || [])
                .filter(item => item.companyId == this.companyId)
                .map(item => {
                return {
                    value: item.systemId,
                    text: item.systemName || ""
                };
            });
            this.systems = [{ value: null, text: `Undefined` }].concat(systems);
            this.working = false;
        });
    }
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        dataCollectorRegistersClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfDataCollectorRegisterModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    getDateTimeFormatted(dateTime) {
        return DateHelper.convertToFriendlyMomentTimeString(dateTime);
    }
    ;
    get siteId() {
        return this.sites.filter(item => {
            return item.value == this.model.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.model.siteId = item.value;
    }
    ;
    get systemId() {
        return this.systems.filter(item => {
            return item.value == this.model.systemId;
        })[0] || null;
    }
    ;
    set systemId(item) {
        if (!item)
            return;
        this.model.systemId = item.value;
    }
    ;
    add() {
        this.getLookups();
        this.model = new DataCollectorRegisterModel();
        this.model.companyId = this.companyId;
        if (this.fileInput)
            this.fileInput.value = '';
        this.showRegisterModal = true;
    }
    fileChanged() {
        if (!this.fileInput)
            return;
        const files = this.fileInput.files;
        if (files && files[0]) {
            const file = files[0];
            if (file.size > 1024 * 1024 * 2) {
                Notifier.onError("File size is too big. Please, select a file smaller than 2 mb!");
                return;
            }
            this.model.fileName = file.name;
            this.model.contentType = file.type;
            // set a timeout to render the button disabled
            this.saveButtonDisabled = true;
            setTimeout(() => {
                const reader = new FileReader;
                reader.onload = e => {
                    this.model.file = e.target.result;
                    this.saveButtonDisabled = false;
                };
                reader.readAsDataURL(file);
            }, 10);
        }
    }
    save() {
        if (!this.model.siteId) {
            Notifier.onWarning("Please, select a site!");
            return;
        }
        if (!this.model.file || !this.model.file.length || !this.model.fileName) {
            Notifier.onWarning("Please, select a valid file first!");
            return;
        }
        var ext = this.model.fileName.slice((Math.max(0, this.model.fileName.lastIndexOf(".")) || Infinity) + 1);
        if (ext.toLowerCase() != 'key') {
            Notifier.onWarning("The file extension should be '.key'. Please, select a valid file!");
            return;
        }
        this.working = true;
        dataCollectorRegistersClient
            .add(new AddDataCollectorRegisterCommand({
            requestModel: this.model
        }))
            .then(() => {
            Notifier.onOk();
            this.working = false;
            this.search();
            this.showRegisterModal = false;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    cancel() {
        this.showRegisterModal = false;
    }
    downloadFile(item) {
        if (!(item === null || item === void 0 ? void 0 : item.id))
            return;
        this.working = true;
        dataCollectorRegistersClient.get(item.id)
            .then((response) => {
            if (!response)
                return;
            let blob = new Blob([`${atob(response.file)}`], { type: 'text/plain;charset=utf-8' });
            DownloadUtil.downloadFile(blob, response.fileName);
            Notifier.onOk(`File downloaded!`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], DataCollectorRegisterVue.prototype, "companyId", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], DataCollectorRegisterVue.prototype, "fileInput", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataCollectorRegisterVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataCollectorRegisterVue.prototype, "onSortChanged", null);
DataCollectorRegisterVue = __decorate([
    Component({
        name: "DataCollectorRegisterVue"
    })
], DataCollectorRegisterVue);
export default DataCollectorRegisterVue;
